const glideList = document.querySelectorAll('.featured-collection-slider__contents');
function initGlide(index) {
  console.log(index);
  if (window.matchMedia("(max-width: 750px)").matches) {
    // 选择相应的元素
    if (glideList[index]) {
      console.log(glideList[index])
      // 创建 Glide 实例并存储在数组中
      new Glide(glideList[index], {
        type: 'carousel',
        startAt: 0,
        perView: 1.5,
        bounds: true,
        dragRatio: 0.5,
        bullets: {
          enabled: true, // 是否启用 Bullets 导航
          container: '.glide__bullets', // Bullets 容器的 CSS 选择器
          dynamicBullets: false, // 是否根据幻灯片数量动态生成 Bullets
          dynamicMainBullets: 1, // 当 dynamicBullets 为 true 时，动态生成的主要 Bullets 数量
          focusClass: 'glide__bullet--active' // 表示当前活动幻灯片的 Bullet 的类名
        }, 
      }).mount();
    }
  }
}
// 页面加载时调用
document.addEventListener('DOMContentLoaded', function() {
  console.log('reloading')
  initGlide(0);
});